import * as React from "react";
import CclInfoTable, {
    CclInfoTableRowTemplate,
} from "../../../../../components/common/cclInfoTable/cclInfoTable";
import { SessionDetailType } from "../../../../../services/types/sessionDetailTypes";
import { CclInfoTblSessionInfoTemplate } from "./cclInfoTblSessionInfoTemplate";
import CclGenericAccordian from "../../../../../components/common/cclGenericAccordian";
import { CclInfoTblSessionProductSaleTemplate } from "./cclInfoTbiSessionProducSaleTemplate";
import { eInfoTableValueFieldEditType } from "../../../../../components/common/cclInfoTable/cclInfoTableValueField";
import { useUpdateProductSaleSessionMutation } from "../../../../../services/cclTokenedSessionApi";
import { AlertColor } from "@mui/material";
import useLogAccessEvent from "../../../../../hooks/useLogAccessEvent";
import { AccessEventSessionDetails } from "../../../../../services/types/accessEventTypes";

interface SessionDetailsAccordionProps {
    sessionDetail: SessionDetailType;
    showSnackbar?: (message: string, severity: AlertColor) => void;
}

const SessionDetailsAccordion: React.FC<SessionDetailsAccordionProps> = (props) => {
    const [template, setTemplate] = React.useState<CclInfoTableRowTemplate[]>([]);
    const [updateProductSaleSession] = useUpdateProductSaleSessionMutation();
    const { logEvent } = useLogAccessEvent();

    React.useEffect(() => {
        let t =
            props.sessionDetail.typeKey === 7
                ? CclInfoTblSessionProductSaleTemplate
                : CclInfoTblSessionInfoTemplate;

        if (props.sessionDetail.typeKey === 7) {
            if (
                props.sessionDetail.assessmentAdminImKey != null &&
                props.sessionDetail.assessmentAdminEmail != null &&
                props.sessionDetail.assessmentAdminEmail !== ""
            ) {
                let url = `/user?email=${encodeURIComponent(
                    props.sessionDetail?.assessmentAdminEmail as string,
                )}&imkey=${props.sessionDetail.assessmentAdminImKey}`;
                let row = t.find((r) => r.id === "assessmentAdmin");
                if (row != null) {
                    row.valueField.editFieldType = eInfoTableValueFieldEditType.Link;
                    row.valueField.url = url;
                }
            }
        } else if (props.sessionDetail.typeKey !== 6) {
            t = t.filter((item) => item.id !== "code");
        }
        setTemplate(t);
    }, [props.sessionDetail]);

    const saveSessionDetails = (e: any) => {
        const titleChange = e.find((f: any) => f.name === "title");
        const customerChange = e.find((f: any) => f.name === "customer");

        let clientName: string | null = null;
        if (customerChange) {
            const val: string = customerChange.value ?? "";
            clientName = val.trim() === "" ? " " : val;
        }

        updateProductSaleSession({
            esKey: props.sessionDetail.sessionKey,
            eventTitle: titleChange ? titleChange.value : null,
            clientName: clientName,
        })
            .unwrap()
            .then(() => {
                const evtData: AccessEventSessionDetails = {
                    sessionID: props.sessionDetail.sessionKey.toString(),
                    projectCode: props.sessionDetail.sessionCode,
                };
                logEvent("SessionSetupSaved", evtData);
                props.showSnackbar?.("Session Updated", "success");
            })
            .catch(() => {
                props.showSnackbar?.("Session Update Failed", "error");
            });
    };

    const languageKey = props.sessionDetail?.languageKey;
    const sessionData = {
        ...props.sessionDetail,
        language:
            languageKey == null || languageKey < 2
                ? "All Available Languages"
                : props.sessionDetail?.language,
    };

    return (
        <CclGenericAccordian headingText="Session" defaultExpanded={true} maximize={true}>
            {props.sessionDetail != null && (
                <CclInfoTable
                    template={template}
                    data={sessionData}
                    onSave={props.sessionDetail.typeKey === 7 ? saveSessionDetails : undefined}
                />
            )}
        </CclGenericAccordian>
    );
};

export default SessionDetailsAccordion;
